<template>
  <div id="my__projects__list" class="project-listing">
    <b-modal centered hide-footer id="viewTitleModal" title="Enter View Title">
      <ViewTitleModal @setActiveView="setActiveView" ref="refViewTitleModal" />
    </b-modal>
    <b-modal centered hide-footer id="viewTitleUpdateModal" title="Enter View Title">
      <ViewTitleModal :title="viewBtnLabel" @setActiveView="setActiveView" :viewId="activeView" ref="refViewTitleModal" />
    </b-modal>
    <!-- Mobile View Select Modal -->
    <b-modal centered id="headerViewSelectModal" hide-footer title="Views" @hidden="viewSelectModalHidden">
      <div id="header-view-select-modal" class="saved-views">
        <div class="view-select-title-header">
          <h4>Views</h4>
          <b-button class="d-block" variant="theme" title="Close View Popup" size="sm" @click="closeVuewSelectModal"><i class="fas fa-times"></i></b-button>
        </div>
        <div class="view-select-body">
          <a
          class="dropdown-item clear-view"
          @click="handleResetFilter(); $bvModal.hide('headerViewSelectModal');"
          href="#"
          v-show="activeView != '-1'"
          >
            Clear View
            <span class="float-right">
            <i class="fas fa-cross text-primary"></i>
            </span>
          </a>
          <a
          class="dropdown-item update-view"
          @click="modalUpdateView"
          href="#"
          v-show="viewModalShowUpdateView"
          >
            Update View
            <span class="float-right">
            <i class="far fa-edit text-primary"></i>
            </span>
          </a>
          <a
          class="dropdown-item save-view"
          @click="modalSaveView"
          href="#"
          v-show="viewModalShowCreateView"
          >
            Save View
            <span class="float-right">
            <i class="fas fa-plus-circle text-primary"></i>
            </span>
          </a>
          <div class="new-view-title-area" v-if="showNewViewTitleArea">
            <div class="row">
              <div class="col-md-12">
                <h5>Save View</h5>
              </div>
            </div>
            <ViewTitleModal @setActiveView="setActiveView" :hasCancelButton="true" @cancelEdit="showNewViewTitleArea = false" />
          </div>
          <div class="update-view-title-area" v-if="showUpdateViewTitleArea">
            <div class="row">
              <div class="col-md-12">
                <h5>Update View</h5>
              </div>
            </div>
            <ViewTitleModal :title="viewBtnLabel" @setActiveView="setActiveView" :viewId="activeView" :hasCancelButton="true" @cancelEdit="showUpdateViewTitleArea = false" />
          </div>
          <div class="views__scroll" ref="views__scroll" v-if="!showNewViewTitleArea && !showUpdateViewTitleArea">
            <div :class="{'scroll__view__btns': !viewModalShowCreateView && !viewModalShowUpdateView}">
            <!-- Preset Views (Hardcode) -->
            <a
            class="dropdown-item"
            :class="{active : activeView == userView.id}"
            @click="loadViewFromModal(userView, index)" :key="'userView'+index+1*Math.random()" v-for="(userView, index) in presetViewsProject"
            href="#"
            >
              <div class="preset-icon-wrap">
              </div>
              <span class="save-title">{{ userView.title }}</span>
            </a>

            <!-- User Views -->
            <a
            class="dropdown-item"
            :class="{active : activeView == userView.id}"
            @click="loadViewFromModal(userView, index)" :key="'userView'+index+1*Math.random()" v-for="(userView, index) in userViewsProject"
            href="#"
            >
              <div class="remove-icon-wrap">
              <span class="remove-icon" @click.stop="removeView(userView.id)">
                <i class="fas fa-trash"></i>
              </span>
              </div>
              <span class="save-title">{{ userView.title }}</span>
            </a>
            </div>
            <div v-if="showNoFilterText" style="padding: 0 23px">
              Add filters to create a custom view
            </div>
          </div>
        </div>
      </div>
    </b-modal>


	  <div class="project__list">
      <div class="project-header">
        <h2 class="d-inline-block">
          <div @click="userCanCreateProject ? createNewProject() : ''" class="project-icon" :class="!userCanCreateProject ? 'pointer-default' : ''">
            <img src="@/csmworkflow/img/projects-black.svg"/>
            <span class="add-project-icon" v-if="userCanCreateProject">
              <img src="@/csmworkflow/img/add-icon.svg"/>
            </span>
          </div>
          My Projects
          <span class="text-muted">({{allUserProjectsPaginationData.total || 0}} projects)</span>
        </h2>
        <span class="d-inline-block float-right saved-views-area" :class="[!showUpdateViewText ? 'pt-15' : '', activeView != '-1' ? 'saved-view-active' : '']">
          <div class="text-right" v-show="showUpdateViewText">
            <a href="#" @click="directUpdateView">Click here</a> to save updated view
          </div>
          <div
          class="btn-group float-right add-new__global_search sorting saved-views"
          >
            <button
              class="btn btn-theme ml-2 header-filter-btns dropdown-toggle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              @click="updatePerfectScroll"
              v-if="!showCreateNewView"
            >
              <span class="updated-view" v-if="showUpdateViewText"></span>
              <span class="mr-3 view__label truncate-text">{{viewBtnLabel}}</span>
              <i v-if="activeView == '-1'" class="fas fa-fw fa-eye text-primary float-right"></i>
              <i v-else v-b-tooltip.hover="{customClass: 'save__view__tooltip'}" title="Clear View" @click.stop="handleResetFilter()" class="fas fa-fw fa-eye text-primary float-right"></i>
            </button>
            <button
              class="btn btn-theme ml-2 header-filter-btns dropdown-toggle save__new__view"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              v-else
            >
              <span class="updated-view" v-if="showUpdateViewText"></span>
              <span class="mr-3 view__label">Views</span>
              <i v-b-tooltip.hover="{ customClass: 'save__view__tooltip' }" title="Save View" @click.stop="saveView" class="fas fa-fw fa-eye text-primary float-right"></i>
            </button>
            <div class="dropdown-menu viewmenu-dropdown">
              <div>
                <a
                class="dropdown-item update-view"
                @click="updateView"
                href="#"
                >
                  Update View
                  <span class="float-right">
                    <i class="far fa-edit text-primary"></i>
                  </span>
                </a>
                <a
                class="dropdown-item save-view"
                @click="saveView"
                href="#"
                >
                  Save View
                  <span class="float-right">
                    <i class="fas fa-plus-circle text-primary"></i>
                  </span>
                </a>
                <perfect-scrollbar class="views__scroll" ref="views__scroll">
                  <div>
                    <!-- Preset Views (Hardcode) -->
                    <a
                    class="dropdown-item"
                    :class="{active : activeView == userView.id}"
                    @click="loadView(userView, index)" :key="'userView'+index+1*Math.random()" v-for="(userView, index) in presetViewsProject"
                    href="#"
                    >
                      <div class="preset-icon-wrap">
                      </div>
                      <span class="save-title">{{ userView.title }}</span>
                    </a>

                    <!-- User Views -->
                    <a
                    class="dropdown-item"
                    :class="{active : activeView == userView.id}"
                    @click="loadView(userView, index)" :key="'userView'+index+1*Math.random()" v-for="(userView, index) in userViewsProject"
                    href="#"
                    >
                      <div class="remove-icon-wrap">
                        <span class="remove-icon" @click.stop="removeView(userView.id)">
                          <i class="fas fa-trash"></i>
                        </span>
                      </div>
                      <span class="save-title">{{ userView.title }}</span>
                    </a>
                  </div>
                  <div v-if="showNoFilterText" style="padding: 0 23px">
                    Add filters to create a custom view
                  </div>
                </perfect-scrollbar>
              </div>
              <!-- <div class="dropdown-item" v-else>
                Views have not been saved yet. Try setting a filter to save your first view.
              </div> -->
            </div>
          </div>
        </span>
        <span class="d-inline-block float-right project-sort" :class="showUpdateViewText ? 'pt-25' : 'pt-15'">
          <div class="btn-group add-new__global_search float-right ml-2 header-filter-btns project-sort-button">
            <button
              class="btn btn-theme header-filter-btns"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span class="sort__label truncate-text">{{projectSortLabel}}</span>
            </button>

            <!-- Sorting dropdown -->
            <div class="dropdown-menu sortmenu-dropdown">
              <div>
                <perfect-scrollbar class="sort__scroll" ref="sort__scroll">
                  <div>
                    <a
                      class="dropdown-item"
                      v-for="(sortOption, index) in sortGroup"
                      :class="{active : sortOption.sorts.includes(projectSortId)}"
                      :key="'projectSort'+index+1*Math.random()"
                      @click="setSort(sortOption)"
                      >
                      <div class="preset-icon-wrap"></div>
                      <span class="sort-title">{{sortOption.title}}</span>
                    </a>
                  </div>
                </perfect-scrollbar>
              </div>
            </div>

            <button class="btn btn-theme" @click.stop="reverseSort()">
              <span class="float-right"><i :class="`fas text-primary ${projectSortIcon}`"></i></span>
            </button>
          </div>
        </span>
      </div>


      <template v-if="!isSortByDepartment">
      <div v-for="(project, index) in userProjects" :key="'project-'+index" :class="getProjectClasses(project)">
        <div class="project-list-no-relation-area">
          <div class="project-no-relation-text"><h2>You are no longer related to the project. <a v-if="activateMyProjectUndo && activateMyProjectUndoId == project.id" @click="undoRelatedProject(project)">Undo (<span class="sec-project">10</span>)</a></h2></div>
          <!-- <div class="project-no-relation-text"><h2>You are no longer related to the project.</h2></div> -->
          <div class="project-no-relation-cross" @click="refreshList(project)"><i class="fas fa-times"></i></div>
        </div>
        <div class="project-list-content">
          <div class="project--list--top--section">

            <div v-b-tooltip.hover title="Open in new tab" class="project--list--icon prj-new-tab cursor-pointer" @click="goToProjectNewTab(project.project_number)"  v-if="!isParentProjectOnHold(project)" :style="{backgroundColor: getProjectColor(project)}">
              <img class="folder-icon" src="@/csmworkflow/img/white-folder.svg" alt="project icon"/>
              <img class="ext-link-icon" src="@/csmworkflow/img/external-link-alt-solid.svg" alt="project icon"/>
            </div>

            <div v-b-tooltip.hover title="Open in new tab" class="project--list--icon on-hold-icon prj-new-tab cursor-pointer" @click="goToProjectNewTab(project.project_number)" v-if="isParentProjectOnHold(project)">
              <img class="on-hold-icon-img" :src="require(`@/csmworkflow/img/project-on-hold-icon.svg`)" alt="On Hold"/>
              <img class="ext-link-icon" src="@/csmworkflow/img/external-link-alt-solid.svg" alt="project icon"/>
            </div>

            

            <div class="top--bar">
              <div class="sections" :class="{'flex-7' : project.total_unread_messages_in_conversation > 0}">
                <div class="top">
                  <!-- <div class="data--item">
                    <span class="text--label">
                      <ProjectDepartments :deliverable="project" />
                    </span>
                  </div> -->
                  <div class="data--item">
                    <span class="text--label">START</span>
                    <span class="text--data">{{ project.created_at | moment("DD MMM, YYYY") }}</span>
                  </div>
                  <div class="data--item":class="{'border-right-none' : project.total_unread_messages_in_conversation > 0}">
                    <span class="text--label">DEADLINE</span>
                    <span class="text--data" v-if="project.due_date">{{ project.due_date | moment("DD MMM, YYYY") }}</span>
                    <span class="text--data" v-else>Not Set</span>
                  </div>
                </div>
                <div class="bottom">
                  <div class="project--department--wrap">
                    <ProjectDepartments :deliverable="project" />
                  </div>
                  <div class="value--item">
                    <span class="edit-d-title" @click.stop="goToProject(project)">
                      {{ project.title }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="sections" 
                v-if="getSystemSetting('is_chat_enabled') &&
                project.total_unread_messages_in_conversation > 0">
                <div class="data--item">
                  <span class="text--label"></span>
                </div>
                <div class="value--item">
                  <div class="d-flex flex-row" @click="goToProject(project)">
                    <ListMessageCounter :deliverable="project" />
                  </div>
                </div>
              </div>
              <!-- <div class="sections">
                <div class="data--item">
                  <span class="text--label">COORDINATORS</span>
                </div>
                <div class="value--item">
                  <ProjectListCoordinator :project="project" />
                </div>
              </div> -->
              <div class="sections" v-if="getSystemSetting('project__show_engagement_manager')" >
                <div class="data--item">
                  <span class="text--label label-desktop">ENGAGEMENT MANAGER</span>
                  <span class="text--label label-mobile">EM</span>
                </div>
                <div class="value--item">
                  <ProjectListEngagementManager :project="project" />
                  <ProjectEngagementManagerLock :project="project" />
                </div>
              </div>
              <div class="sections">
                <div class="data--item" v-if="getSystemSetting('project__project_lead_label')">
                  <span class="text--label label-desktop">
                  {{ getSystemSetting('project__project_lead_label') }}
                  </span>
                  <span class="text--label label-mobile">
                  {{ getSystemSetting('project__project_lead_label') | textInitials }}
                  </span>
                </div>
                <div class="data--item" v-else>
                  <span class="text--label label-desktop">PROJECT LEAD</span>
                  <span class="text--label label-mobile">PL</span>
                </div>
                <div class="value--item">
                  <ProjectListProjectLeaders :project="project" />
                </div>
              </div>
              <!-- <div class="sections">
                <div class="data--item">
                  <span class="text--label">MEDIA BUDGET</span>
                </div>
                <div class="value--item">
                  <span>
                    <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'media_budget'})" :key="field.id*Math.random()">
                      <div class="media-budget-value">
                        <ProjectCustomFields :deliverable="project" :customField="field" />
                    </div>
                  </span>
                </div>
              </div> -->
              <div class="sections">
                <div class="data--item">
                  <span class="text--label">STATUS</span>
                </div>
                <div class="value--item" style="width: 100%; padding-right: 10px;">
                  <span style="flex-basis: 100%">
                    <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'project_status'})" :key="field.id*Math.random()">
                      <div class="requisition-number-value">
                        <ProjectCustomFields :deliverable="project" :customField="field" />
                      </div>
                    </div>
                </span>
              </div>
            </div>
            <div class="sections" v-if="showProjectCustomField(project, 'requisition_number')" >
              <div class="data--item">
                <span class="text--label label-desktop">REQUISITION NUMBER</span>
                <span class="text--label label-mobile">REQUISITION #</span>
              </div>
                <div class="value--item">
                  <span>
                    <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'requisition_number'})" :key="field.id*Math.random()">
                      <div class="requisition-number-value">
                        <ProjectCustomFields :deliverable="project" :customField="field" />
                      </div>
                    </div>
                  </span>
                </div>
              </div>
              <div class="sections">
                <div class="data--item">
                  <span class="text--label">BUDGET</span>
                </div>
                <div class="value--item">
                  <span>
                    <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'budget'})" :key="field.id*Math.random()">
                      <div class="budget-value">
                        <ProjectCustomFields :deliverable="project" :customField="field" />
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </template>


      <template v-if="isSortByDepartment">
      <div v-for="(department, index) in grouppedProject" :key="'department-'+index">
        <div v-if="department.title == null" class="project-department-group-header">
          <h2>No Department</h2>
        </div>
        <div v-else class="project-department-group-header">
          <h2>{{department.title}}</h2>
        </div>
      <div v-for="(project, index) in department.projects" :key="'project-'+index"  :class="getProjectClasses(project)">
        <div class="project--list--top--section">


          <div v-b-tooltip.hover title="Open in new tab" class="project--list--icon prj-new-tab cursor-pointer" @click="goToProjectNewTab(project.project_number)"  v-if="!isParentProjectOnHold(project)" :style="{backgroundColor: getProjectColor(project)}">
          	<img class="folder-icon" src="@/csmworkflow/img/white-folder.svg" alt="project icon"/>
          	<img class="ext-link-icon" src="@/csmworkflow/img/external-link-alt-solid.svg" alt="project icon"/>
          </div>

          <div v-b-tooltip.hover title="Open in new tab" class="project--list--icon on-hold-icon prj-new-tab cursor-pointer" @click="goToProjectNewTab(project.project_number)" v-if="isParentProjectOnHold(project)">
          	<img class="on-hold-icon-img" :src="require(`@/csmworkflow/img/project-on-hold-icon.svg`)" alt="On Hold"/>
          	<img class="ext-link-icon" src="@/csmworkflow/img/external-link-alt-solid.svg" alt="project icon"/>
          </div>



          <div class="top--bar">
            <div class="sections" :class="{'flex-7' : project.total_unread_messages_in_conversation > 0}">
              <div class="top">
                <!-- <div class="data--item">
                  <span class="text--label">
                    <ProjectDepartments :deliverable="project" />
                  </span>
                </div> -->
                <div class="data--item">
                  <span class="text--label">START</span>
                  <span class="text--data text-uppercase">{{ project.created_at | moment("DD MMM, YYYY") }}</span>
                </div>
                <div class="data--item" :class="{'border-right-none' : project.total_unread_messages_in_conversation > 0}">
                  <span class="text--label">DEADLINE</span>
                  <span class="text--data text-uppercase" v-if="project.due_date">{{ project.due_date | moment("DD MMM, YYYY") }}</span>
                  <span class="text--data text-uppercase" v-else>Not Set</span>
                </div>
              </div>
              <div class="bottom">
                <div class="project--department--wrap">
                  <ProjectDepartments :deliverable="project" />
                </div>
                <div class="value--item">
                  <span class="edit-d-title" @click.stop="goToProject(project)">
                    {{ project.title }}
                  </span>
                </div>
              </div>
            </div>
            <div class="sections" 
              v-if="getSystemSetting('is_chat_enabled') &&
              project.total_unread_messages_in_conversation > 0">
              <div class="data--item">
                <span class="text--label"></span>
              </div>
              <div class="value--item">
                <div class="d-flex flex-row" @click="goToProject(project)">
                  <ListMessageCounter :deliverable="project" />
                </div>
              </div>
            </div>
            <!-- <div class="sections">
              <div class="data--item">
                <span class="text--label">COORDINATORS</span>
              </div>
              <div class="value--item">
                <ProjectListCoordinator :project="project" />
              </div>
            </div> -->
            <div class="sections" v-if="getSystemSetting('project__show_engagement_manager')" >
              <div class="data--item">
                <span class="text--label label-desktop">ENGAGEMENT MANAGER</span>
                <span class="text--label label-mobile">EM</span>
              </div>
              <div class="value--item">
                <ProjectListEngagementManager :project="project" />
                <ProjectEngagementManagerLock :project="project" />
              </div>
            </div>
            <div class="sections">
              <div class="data--item" v-if="getSystemSetting('project__project_lead_label')">
                <span class="text--label label-desktop">
                {{ getSystemSetting('project__project_lead_label') }}
                </span>
                <span class="text--label label-mobile">
                {{ getSystemSetting('project__project_lead_label') | textInitials }}
                </span>
              </div>
              <div class="data--item" v-else>
                <span class="text--label label-desktop">PROJECT LEAD</span>
                <span class="text--label label-mobile">PL</span>
              </div>
              <div class="value--item">
                <ProjectListProjectLeaders :project="project" />
              </div>
            </div>
            <!-- <div class="sections">
              <div class="data--item">
                <span class="text--label">MEDIA BUDGET</span>
              </div>
              <div class="value--item">
                <span>
                  <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'media_budget'})" :key="field.id*Math.random()">
                    <div class="media-budget-value">
                      <ProjectCustomFields :deliverable="project" :customField="field" />
                    </div>
                  </div>
                </span>
              </div>
            </div> -->
            <div class="sections">
              <div class="data--item">
                <span class="text--label">STATUS</span>
              </div>
              <div class="value--item" style="width: 100%; padding-right: 10px;">
                <span style="flex-basis: 100%">
                  <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'project_status'})" :key="field.id*Math.random()">
                    <div class="requisition-number-value">
                      <ProjectCustomFields :deliverable="project" :customField="field" />
                    </div>
                  </div>
                </span>
              </div>
            </div>
            <div class="sections" v-if="showProjectCustomField(project, 'requisition_number')" >
              <div class="data--item">
                <span class="text--label label-desktop">REQUISITION NUMBER</span>
                <span class="text--label label-mobile">REQUISITION #</span>
              </div>
              <div class="value--item">
                <span>
                  <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'requisition_number'})" :key="field.id*Math.random()">
                    <div class="requisition-number-value">
                      <ProjectCustomFields :deliverable="project" :customField="field" />
                    </div>
                  </div>
                </span>
              </div>
            </div>
            <div class="sections">
              <div class="data--item">
                <span class="text--label">BUDGET</span>
              </div>
              <div class="value--item">
                <span>
                  <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'budget'})" :key="field.id*Math.random()">
                    <div class="budget-value">
                      <ProjectCustomFields :deliverable="project" :customField="field" />
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </template>

      <!-- <div 
        class="deliverable-block project-block"
        v-for="(project, index) in userProjects"
        :key="'project-'+index"
      >
        <div class="delv-block-resp">
          <div class="d-flex flex-row dbox-wrapper">
            <div class="w-100 dbox-left-side">
              <div class="row listing-row">
                <div class="col-md-4 titles breakpoint__fix">
                  <div v-b-tooltip.hover title="Priority" class="listing-priority" @click="setPriority(project)" :class="'listing-priority-del-'+project.id">
                    <vue-star-rate
                      :rateRange="project.priority ? Number(project.priority) : 0"
                      :maxIcon="5"
                      :iconHeight="17"
                      :iconWidth="17"
                      :hasCounter="false"
                      :key="'del-rating-'+Math.random()+project.id"
                      iconColor="#fff"
                      iconColorHover="#fff"
                      iconShape="circle"
                    ></vue-star-rate>
                  </div>
                  <div class="inside-list">
                    <ProjectDepartments :deliverable="project" />
                  </div>
                  <div
                    class="deliverable-title edit-d-title"
                    @click="$router.push('/project/' + project.id)"
                  >{{ project.title }}</div>
                </div>
                <div v-if="!isMobile()" class="col-md-6 infos">
                  <div class="d-flex flex-row">
                    <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'budget'})" :key="field.id*Math.random()">
                      <div class="budget-value">
                        <ProjectCustomFields :deliverable="project" :customField="field" />
                      </div>
                    </div>
                    <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'media_budget'})" :key="field.id*Math.random()">
                      <div class="media-budget-value">
                        <ProjectCustomFields :deliverable="project" :customField="field" />
                      </div>
                    </div>
                    <div class="info-item" v-for="(field, index) in _.filter(project.customFields, {field_key: 'requisition_number'})" :key="field.id*Math.random()">
                      <div class="requisition-number-value">
                        <ProjectCustomFields :deliverable="project" :customField="field" />
                      </div>
                    </div>
                    <ProjectListCoordinator :project="project" />
                  </div>
                </div>
                <div class="col-md-2 breakpoint__fix project-dates-wrapper" :class="'deliv-'+index">
                  <ProjectDatesRibbon :deliverable="project" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="mb-5" v-if="!userHasProjects"><h2>No projects</h2></div>
      <div class="pagination-wrapper">
        <pagination :data="allUserProjectsPaginationData" @pagination-change-page="onChangePage" :limit="5"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import vueStarRate from "vue-js-star-rating";
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ListMessageCounter from "./ListMessageCounter";
import EditProjectModal from "./EditProjectModal";
import ProjectDatesRibbon from "./ProjectDatesRibbon";
import ProjectDepartments from "./ProjectDepartments";
import ProjectListCoordinator from "./ProjectListCoordinator";
import ProjectCustomFields from "../common/ProjectCustomField";
import ProjectListEngagementManager from './ProjectListEngagementManager';
import ProjectEngagementManagerLock from './ProjectEngagementManagerLock';
import ProjectListProjectLeaders from './ProjectListProjectLeaders';
import ViewTitleModal from "../common/ViewTitleModal";
import toast from '../../toast';
export default {
	data() {
		return {
			viewBtnLabel: "Views",
			activeView: '-1',
			showUpdateViewText: false,
			showCreateNewView: false,
			currentViewData: {},
			viewModalShowCreateView: false,
			viewModalShowUpdateView: false,
			showNewViewTitleArea: false,
			showUpdateViewTitleArea: false,
      showNoFilterText: false,
			lastFilterJson: null,

			projectSortLabel: "Created Date",
			projectSortIcon: "fa-sort-amount-down",
			projectSortId: 0,
		}
	},
	components: {
		ProjectCustomFields,
		EditProjectModal,
		ListMessageCounter,
		ProjectDatesRibbon,
		vueStarRate,
		ProjectDepartments,
		ProjectListCoordinator,
		ProjectListEngagementManager,
    ProjectEngagementManagerLock,
		ProjectListProjectLeaders,
		ViewTitleModal,
	},
	computed: {
		...mapGetters([
			'dataLoading',
			'userProjects',
			'projectDetail',
			'allUserProjectsPaginationData',
			"systemSettings",
			"getSystemSetting",
			'userAbilities',
      'userHasProjects',
      'activateMyProjectUndo',
      'activateMyProjectUndoId',
			'userViews',
			'myProjectFilter',
		]),
		_() {
			return _;
		},
		userCanCreateProject() {
			return this.userAbilities.createProject;
		},
		userViewsProject() {
			return _.filter(this.userViews, {view_type: "myProjects"});
		},

		presetViewsProject() {
			return [];
		},

		// Hardcoded sorts
		sortOptions() {
			return [
				{
					id: 1,
					title: 'Project Title (A-Z)',
					sortString: 'titleAsc',
					icon: 'fa-sort-alpha-down'
				},
				{
					id: 2,
					title: 'Project Title (Z-A)',
					sortString: 'titleDesc',
					icon: 'fa-sort-alpha-up'
				},
				{
					id: 3,
					title: 'Department (A-Z)',
					sortString: 'departmentAsc',
					icon: 'fa-sort-alpha-down',
          default: true
				},
				{
					id: 4,
					title: 'Department (Z-A)',
					sortString: 'departmentDesc',
					icon: 'fa-sort-alpha-up'
				},
			];
		},
    sortGroup() {
      return [
        {
          id: 10,
          title: 'Project Title',
          sorts: [1,2]
        },
        {
          id: 11,
          title: 'Department',
          sorts: [3,4]
        },
      ]
    },

    // Accomodate for department grouping
		grouppedProject() {
			let departmentsOnPage = [];
			this.userProjects.forEach(x => {
				if (!this._.find(departmentsOnPage, {id: x.sort_department_id})) {
					departmentsOnPage.push({
						id: x.sort_department_id,
						title: x.sort_department_name,
						projects: [],
					});
				}

				const depObj = this._.find(departmentsOnPage, {id: x.sort_department_id});
				depObj.projects.push(x);
			});

			return departmentsOnPage;
		},
		isSortByDepartment() {
			// const filter = this.$store.getters.projectFilter;
			const dataHasSort = this.userProjects[0] && typeof this.userProjects[0].sort_department_id != 'undefined';
			// return filter.sort == ('departmentAsc' || filter.sort == 'departmentDesc') || dataHasSort;
			return dataHasSort;
		}
	},
	created() {
		this.fetchDepartments();
		this.fetchActiveDepartments();
		this.fetchUsers();
		this.fetchActiveUsers();
		this.fetchViews();
		this.fetchSystemSettings();
	},
	methods: {
		...mapActions([
      'fetchUserProjects',
      'fetchDepartments',
      'fetchActiveDepartments',
			'fetchUsers',
			'fetchActiveUsers',
			'updateProjectFieldValue',
			'fetchProjectDeliverableById',
			'fetchProjectUnreadMessageCount',
			'fetchViews',
			"fetchSystemSettings",
      "toggleProjectEngagementManagerLock",
		]),
		...mapMutations([
			"setDataLoading",
		]),
		showProjectCustomField(project, fieldKey) {
			const projectCustomFieldArray = this._.filter(project.projectCustomFields, { field_key: fieldKey });
			if (Array.isArray(projectCustomFieldArray) && projectCustomFieldArray.length) {
				// array exist, is not empty
				return true;
			}
			return false;
		},
		createNewProject() {
			let that = this;
			this.$store.dispatch("createNewProject").then((resp) => {
				// that.$bvModal.show("editProjectModal");
				// let projectId = resp.id;
				let projectId = resp.project_number;
				this.$store.commit("setNewProjectCreated", true);
				// that.$router.push('/project/' + projectId);
				that.goToProject(projectId);
				that.$forceUpdate();
				that.$store.dispatch("fetchProjects");
			});
		},
		setPriority(project) {
			let priority = $('.listing-priority-del-'+project.id+' .vue-star-rate ul.list li.active').length;
			let priorityField = _.filter(project.customFields, {field_key: 'priority'})[0];
			let priorityData = {
				field_id: priorityField.field_id,
				parent_id: null,
				value: priority,
				project_id: project.id,
				projectFieldId: priorityField.projectFieldId,
				id: project.id
			};
			this.updateProjectFieldValue(priorityData);
		},
		editProjectModalHidden() {
			this.$store.commit('setProject', this.projectDetail)
		},

		onChangePage(page) {
			this.$router.push({
				name: 'myProjects',
				query: { page }
			});
		},
		pushRoute() {
			if(this.$router.currentRoute.path.indexOf('my-projects/') == -1) {
				history.pushState(
					{},
					null,
					'my-projects/' + encodeURIComponent(this.projectDetail.id) + '/' + encodeURIComponent(this.projectDetail.slug)
				)
			}
		},
		showModalFn(projectId) {
			this.$store
				.dispatch("getProjectDetail", { projectId })
				.then(() => {
					this.$bvModal.show("editProjectModal");
				});
		},
		removeRoute() {
			if (this.$router.currentRoute.path.indexOf('my-projects/') != -1) {
					const currentPage = this.$route.query.page || 1;
					this.$router.push({
					name: 'myProjects',
					query: { page: currentPage }
				});

			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
			}
		},

		userCanEditProject(project) {
			const userId = localStorage.getItem("userId");

			if (this.userAbilities.accessAllProjects) {
				return true;
			}

			let isManager = false;
			if (project.engagement_manager instanceof Object && project.project_leaders instanceof Object) {
					isManager = userId == project.engagement_manager.id;
					if (!isManager) {
						for(var l in project.project_leaders) {
							if (l.id == userId) {
								isManager = true;
							}
						}
					}
			} else {
				if (project.engagement_manager instanceof Object && project.project_lead instanceof Object) {
					isManager = userId == project.engagement_manager.id;
				} else {
					isManager = userId == project.engagement_manager;
				}
			}

			return (this.userAbilities.editProject && isManager);
		},
    userCanAddDeliverable(project) {
      const userId = localStorage.getItem("userId");

			if (this.userAbilities.accessAllProjects) {
				return true;
			}
			
			let isManager = false;
			if (project.engagement_manager instanceof Object && project.project_leaders instanceof Object) {
					isManager = userId == project.engagement_manager.id;
					if (!isManager) {
						for(var l in project.project_leaders) {
							if (l.id == userId) {
								isManager = true;
							}
						}
					}
			} else {
				if (project.engagement_manager instanceof Object && project.project_lead instanceof Object) {
					isManager = userId == project.engagement_manager.id || userId == project.project_lead.id;
				} else {
					isManager = userId == project.engagement_manager || userId == project.project_lead;
				}
			}

      return (this.userAbilities.createMediaCall && isManager);
    },
		goToProjectNewTab(projectId) {
			this.setDataLoading(true);
			this.fetchProjectDeliverableById(projectId).then(() => {
				this.setDataLoading(false);
				window.open('/my-projects/' + projectId);
			});
		},
		goToProject(project) {
			sessionStorage.setItem('lastViewedMyProject', project.id);
			this.setDataLoading(true);
			this.fetchProjectDeliverableById(project.project_number).then(() => {
				this.setDataLoading(false);
				this.$router.push({ path: '/my-projects/' + project.project_number, query: {} });
			});
		},
		goToProjectDeliverable(projectId) {
			this.setDataLoading(true);
			this.fetchProjectDeliverableById(projectId).then(() => {
				this.setDataLoading(false);
				this.$router.push('/my-projects/' + projectId + "?activeTab=0");
			});
		},
		goToProjectNewDeliverable(projectId) {
			this.setDataLoading(true);
			this.fetchProjectDeliverableById(projectId).then(() => {
				this.setDataLoading(false);
				this.$router.push('/my-projects/' + projectId + "?activeTab=0&newDeliverable=1");
			});
		},

    // View functions
		handleResetFilter() {
			$('.viewmenu-dropdown').removeClass('show');
			this.resetView();
		},
		directUpdateView() {
			this.showUpdateViewText = false;
			let view = "";
			if (this.$router.currentRoute.name == "project") {
				view = this.$store.getters.projectFilter;
			} else if (this.$router.currentRoute.name == "myProjects") {
				view = this.$store.getters.myProjectFilter;
			}
			let viewData = {
					title: this.viewBtnLabel,
					filterQuery: view,
					viewId: this.activeView
				};
			let that = this;
			this.$store.dispatch("saveView", viewData).then(function() {
				if(that.$router.currentRoute.name == 'project') {
					localStorage.setItem('projectActiveSaveData', JSON.stringify(view));
				} else if(that.$router.currentRoute.name == 'myProjects') {
					localStorage.setItem('myProjectActiveSaveData', JSON.stringify(view));
				}
				that.setActiveView();
				toast.info('View has been saved.');
			});
		},
		saveView() {
			this.$bvModal.show("viewTitleModal");
		},
		updatePerfectScroll() {
			let self = this;
			setTimeout(function() {
				if(typeof self.$refs.views__scroll != 'undefined') {
					self.$refs.views__scroll.update();
				}
			}, 1);
		},

		isParentProjectOnHold(project) {
			var project_status = _.filter(project.customFields, {field_key: 'project_status'});
			for (var x in project_status) {
				var status = JSON.parse(project_status[x].value);
				if (status.slug) {
					if (status.slug == "on-hold") {
						return true;
					}
				}
			}
			return false;
		},

		getProjectClasses(project) {
			var classes = "project--block--wrap project--block--animated";
			if (!this.userCanEditProject(project)) {
				classes += " read-only";
			}

			classes += " project-id-"+project.id;

			var project_status = _.filter(project.customFields, {field_key: 'project_status'});
			for (var x in project_status) {
				var status = JSON.parse(project_status[x].value);
				if (status.slug) {
					if (status.slug == "on-hold") {
						classes += " project-on-hold-row";
					}
				}
			}

			return classes;
		},

		updateView() {
			this.$bvModal.show("viewTitleUpdateModal");
		},
		loadView(viewData) {
			this.currentViewData = JSON.parse(viewData.saved_data);
			let index = viewData.id;
			this.showUpdateView = true;
			this.viewBtnLabel = viewData.title;
			if(this.$router.currentRoute.name == 'project') {
				this.activeView = index;
				localStorage.setItem('projectActiveSave', index);
				localStorage.setItem('projectActiveSaveTitle', viewData.title);
				localStorage.setItem('projectActiveSaveData', viewData.saved_data);
			} else if(this.$router.currentRoute.name == 'myProjects') {
				this.activeView = index;
				localStorage.setItem('myProjectActiveSave', index);
				localStorage.setItem('myProjectActiveSaveTitle', viewData.title);
				localStorage.setItem('myProjectActiveSaveData', viewData.saved_data);
			}
			if(this.$router.currentRoute.name == 'project') {
				this.$store.commit('setProjectFilter', viewData.saved_data);
				this.$root.$emit('setSaveView', this.$store.getters.projectFilter);
				// this.filterQuery = this.$store.getters.deliverableFilter;
			} else if(this.$router.currentRoute.name == 'myProjects') {
				this.$store.commit('setMyProjectFilter', viewData.saved_data);
				this.$root.$emit('setSaveView', this.$store.getters.myProjectFilter);
				// this.filterQuery = this.$store.getters.myWeekDeliverableFilter;
			}
		},
		removeView(viewId) {
			if(this.$router.currentRoute.name == 'project') {
				if(viewId == localStorage.getItem('projectActiveSave')) {
					this.resetView();
				}
			} else if(this.$router.currentRoute.name == 'myProjects') {
				if(viewId == localStorage.getItem('myProjectActiveSave')) {
					this.resetView();
				}
			}
			this.$store.dispatch('removeView', viewId);
		},
		setActiveView() {
			if(this.$router.currentRoute.name == 'project') {
				if(localStorage.getItem('projectActiveSave')) {
					this.activeView = localStorage.getItem('projectActiveSave');
					this.viewBtnLabel = localStorage.getItem('projectActiveSaveTitle');
					this.currentViewData = localStorage.getItem('projectActiveSaveData');
					this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			} else if(this.$router.currentRoute.name == 'myProjects') {
				if(localStorage.getItem('myProjectActiveSave')) {
					this.activeView = localStorage.getItem('myProjectActiveSave');
					this.viewBtnLabel = localStorage.getItem('myProjectActiveSaveTitle');
					this.currentViewData = localStorage.getItem('myProjectActiveSaveData');
					this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			}
		},
		resetView() {
			localStorage.removeItem("projectActiveSave");
			localStorage.removeItem("myProjectActiveSave");
			this.setActiveView();
		},
		viewSelectModalHidden() {
			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		loadViewFromModal(viewData) {
			this.loadView(viewData);
			this.$bvModal.hide("headerViewSelectModal");
		},
		modalUpdateView() {
			this.showUpdateViewTitleArea = true;
		},
		modalSaveView() {
			this.showNewViewTitleArea = true;
		},

		// Sorting functions
		setSort(sortGroup) {
			let sortOption;
			if (sortGroup.sorts.includes(this.projectSortId)) {
				let curIndex = this._.findIndex(sortGroup.sorts, x => x == this.projectSortId);
				curIndex += 1;
				if (curIndex >= sortGroup.sorts.length) curIndex = 0;
				let newId = sortGroup.sorts[curIndex];
				sortOption = this._.find(this.sortOptions, {id: newId});
			} else {
				sortOption = this._.find(this.sortOptions, {id: sortGroup.sorts[0]});
			}

			this.$store.commit("setMyProjectSort", sortOption.sortString);
			const currentPage = Number(this.$route.query.page) || 1;
			this.onChangePage(currentPage);

			this.projectSortLabel = sortGroup.title;
			this.projectSortIcon = sortOption.icon;
			this.projectSortId = sortOption.id;
		},
		loadSortFromFilter() {
			let sortString = this.$store.getters.projectSort;
			let currentSort;
			if (sortString) {
				currentSort = this._.filter(this.sortOptions, {sortString: sortString})[0];
			}
			else {
				currentSort = this._.filter(this.sortOptions, {default: true})[0];
			}

			let currentSortGroup = this._.find(this.sortGroup, x => x.sorts.includes(currentSort.id));

			if (currentSort) {
				this.projectSortLabel = currentSortGroup.title;
				this.projectSortIcon = currentSort.icon;
				this.projectSortId = currentSort.id;
			}
		},
		reverseSort() {
			let curSortGroup;
			for (let i in this.sortGroup) {
				if (this.sortGroup[i].sorts.includes(this.projectSortId)) {
					curSortGroup = this.sortGroup[i];
					break;
				}
			}

			this.setSort(curSortGroup);
		},
		closeVuewSelectModal() {
			this.$bvModal.hide("headerViewSelectModal");
		},
	},
	watch: {
		'$route.query.page'(newPage, oldPage) {
			if (Number(newPage) !== Number(oldPage)) {
				this.setDataLoading(true);
				this.fetchUserProjects(Number(newPage)).then(() => {
					this.setDataLoading(false);
					this.$nextTick(() => {
						const el = 
							document.getElementById('content') ||
							document.documentElement;
						if (el) {
							el.scrollTo({
								top: 0,
								behavior: 'smooth'
							});
						}
					});
				});
			}
		},
		userProjects(newItems, oldItems) {
			if (!this.dataLoading && newItems && newItems.length > 0 && oldItems.length === 0) {
				this.fetchProjectUnreadMessageCount("my-projects");
			}
		},
		myProjectFilter: {
			deep: true,
			handler(newVal) {
				const newJson = JSON.stringify(newVal);
				if (newJson === this.lastFilterJson) {
					return;
				}
        this.lastFilterJson = newJson;
        const currentPage = Number(this.$route.query.page) || 1;
        if (!this.$route || !this.$route.query) return;
				if (currentPage !== 1) {
					this.$router.push({
						name: 'myProjects',
						query: { page: 1 }
					});
				} else {
					this.setDataLoading(true);
					this.fetchUserProjects(1).then(() => {
						this.setDataLoading(false);
					});
				}
			}
		}
	},
  mounted() {
    this.lastFilterJson = JSON.stringify(this.myProjectFilter);
    let that = this;
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      if (modalId == "editProjectModal") {
        that.$store.state.deliverables.editProjectModal = false;
      }
    });
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "editProjectModal") {
        this.$store.state.deliverables.editProjectModal = true;
      }
    });

    // View events
		this.$root.$on('updateListTitle', function(title) {
			that.listTitle = title;
		});
		this.setActiveView();

		this.$root.$on('hideUpdateText', function() {
			that.showUpdateViewText = false;
		});
		this.$root.$on('resetView', function() {
			that.resetView();
		});
		let tempJson3 = false;
		this.$root.$on('showUpdateViewText', function(payload) {
			if(that.$router.currentRoute.name != 'project' && that.$router.currentRoute.name != 'myProjects') return;

			let currentFilter = payload.currentFilter
			let excludedKeys = ['myWeek'];
			let tempJson1 = currentFilter;

			if(!payload.isFilterActive) {
				that.activeView = '-1'
				that.viewBtnLabel = 'Views'
			}

			let tempJson2 = that.activeView != '-1' ? that.currentViewData : false;
			if(typeof tempJson2 == 'string') {
				tempJson2 = JSON.parse(that.currentViewData);
			}

			that.showUpdateViewText = false;
			if(tempJson2) {
				Object.entries(currentFilter).forEach(([key, value]) => {
					if(typeof tempJson2[key] != 'undefined' 
						&& excludedKeys.indexOf(key) == -1) {
						if(key == 'dateRange' || key == 'dateCreatedRange' || key == 'dateCompletedRange') {
							let tempDateFlags = {
								dateRange: 'filterByDate',
								dateCreatedRange: 'filterByDateCreated',
								dateCompletedRange: 'filterByDateCompleted'
							};
							if(tempJson2[tempDateFlags[key]]) {
								let temp1StartDate = (typeof tempJson1[key].startDate != 'string') ? tempJson1[key].startDate.toISOString() : tempJson1[key].startDate,
									temp1EndDate = (typeof tempJson1[key].endDate != 'string') ? tempJson1[key].endDate.toISOString() : tempJson1[key].endDate,
									temp2StartDate = (typeof tempJson2[key].startDate != 'string') ? tempJson2[key].startDate.toISOString() : tempJson2[key].startDate,
									temp2EndDate = (typeof tempJson2[key].endDate != 'string') ? tempJson2[key].endDate.toISOString() : tempJson2[key].endDate;
								if((temp1StartDate.substr(0, 10) != temp2StartDate.substr(0, 10)) && temp1EndDate.substr(0, 10) != temp2EndDate.substr(0, 10)) {
									if ((typeof that.activeView).toLowerCase() == "string" && that.activeView.startsWith('p')) {
										that.activeView = -1;
									} else {
										that.showUpdateViewText = true;
									}
									return;
								}
							}
						} else {
							if(JSON.stringify(tempJson1[key]) != JSON.stringify(tempJson2[key])) {
								if ((typeof that.activeView).toLowerCase() == "string" && that.activeView.startsWith('p')) {
									that.activeView = -1;
                } else if (that.activeView == -1) {
								} else {
									that.showUpdateViewText = true;
								}
								return;
							}
						}
					} 
				});
			}
		});

    // Load sort
		this.loadSortFromFilter();
		const page = Number(this.$route.query.page) || 1;
		this.setDataLoading(true);
		this.fetchUserProjects(page).then(() => {
			this.setDataLoading(false);
			const lastViewedProject = sessionStorage.getItem('lastViewedMyProject');
			if (!lastViewedProject) return;
			this.$nextTick(() => {
				const content = document.getElementById('content');
				const projectEl = document.querySelector(
					`.project-id-${lastViewedProject}`
				);
				if (!content || !projectEl) return;
				const contentRect = content.getBoundingClientRect();
				const projectRect = projectEl.getBoundingClientRect();
				const targetScrollTop =
					projectRect.top -
					contentRect.top +
					content.scrollTop -
					content.clientHeight / 2;
				content.scrollTo({
					top: targetScrollTop,
					behavior: 'smooth'
				});
				sessionStorage.removeItem('lastViewedMyProject');
			});
		});
	},
	beforeUpdate() {
		if(this.activeView != '-1' && ((typeof this.activeView).toLowerCase() == "string" ? !this.activeView.startsWith('p') : true)) {
			$('.views__scroll > div').removeClass('scroll__view__btns');
			$('.update-view').removeClass('d-none');			
		} else {
			$('.views__scroll > div').addClass('scroll__view__btns');
			$('.update-view').addClass('d-none');
		}
		if(!$('.project-listing').hasClass('hasFilter')) {
			$('.save-view').addClass('d-none');
			$('.update-view').addClass('d-none');
			this.showUpdateViewText = false;
			$('.views__scroll > div').addClass('scroll__view__btns');
			this.showCreateNewView = false;
		} else {
			$('.save-view').removeClass('d-none');
			
			if(this.activeView == '-1') {
				this.showCreateNewView = true;
			} else {
				this.showCreateNewView = false;
			}
		}
		if($('.save-view').hasClass('d-none') && $('.update-view').hasClass('d-none')) {
			$('.views__scroll > div').addClass('scroll__view__btns');
		} else {
			$('.views__scroll > div').removeClass('scroll__view__btns');
		}

    this.viewModalShowCreateView = !$('.save-view').hasClass('d-none');
		this.viewModalShowUpdateView = !$('.update-view').hasClass('d-none');
	},
}
</script>

<style>

</style>